export const prepareDashboard = (data = []) => ({
  month: data.filter((item) => item.period === 'MONTHLY'),
  year: data.filter((item) => item.period === 'YEARLY'),
  total: data.filter((item) => item.period === 'ALL'),
});
